import { Navigate, useLocation } from "react-router-dom";

/** Redirection d'une ancienne route vers sa nouvelle destination (conserve la query si demandé). */
export default function LegacyRedirect({ to, keepQuery = false }) {
  const { search } = useLocation();
  const [path, q] = to.split("?");
  const merged = new URLSearchParams(keepQuery ? search : "");
  if (q) new URLSearchParams(q).forEach((v, k) => merged.set(k, v));
  const qs = merged.toString();
  return <Navigate replace to={qs ? `${path}?${qs}` : path} />;
}
